module.exports = __webpack_public_path__ + "87b2bc4de6138affcdf0fe3b2acc385a.png";